import { IconName } from '@tallo/design-system';

export enum PropertyOnboardingStage {
  BASIC_DETAILS = 'basic-details',
  ADDITIONAL_DETAILS = 'additional-details',
  MARKETING_DETAILS = 'marketing-details',
}

export enum PropertyOnboardingStep {
  ADDRESS = 'address',
  PROPERTY_TYPE = 'property-type',
  SPECIFICATIONS = 'specifications',
  LEASE_CONDITIONS = 'lease-conditions',
  PET_POLICY = 'pet-policy',
  LEASE_TERMS = 'lease-terms',
  RENTER_REQUIREMENTS = 'renter-requirements',
  IMAGES = 'images',
  DESCRIPTION = 'description',
  AVAILABILITY = 'availability',
  TOUR_TYPES = 'tour-types',
}

export interface PropertyOnboardingStageMetaData {
  stageName: PropertyOnboardingStage;
  icon: IconName;
  iconColor: 'green' | 'blue' | 'violet';
  title: string;
}
